import axios from "../../../../utils/request"

function GET_LIST(params) {
    return  axios.post("/detect/MAdRegisterRecordGoogle/index",{...params} )
}

function EXPORT(params) {
    return  axios.post("/detect/MAdRegisterRecordGoogle/export",{...params} )
}
export default {
    GET_LIST,
    EXPORT
}
